export default __webpack_public_path__ + "static/media/Inter-ThinItalic.626503a6.woff2";